function FacebookWhite() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M17.0208 0.000112881H2.97952C1.33682 0.000112881 0.000134638 1.32417 0.000134638 2.95134V17.0489C0.000134638 18.6761 1.33682 20.0001 2.97952 20.0001H8.97801V13.0249H6.5945V9.4834H8.97801V7.08306C8.97801 5.13018 10.5818 3.54159 12.5533 3.54159H16.1683V7.08306H12.5533V9.4834H16.1683L15.5724 13.0249H12.5533V20.0001H17.0208C18.6634 20.0001 20.0001 18.6761 20.0001 17.0489V2.95134C20.0001 1.32417 18.6634 0.000112881 17.0208 0.000112881Z"
        fill="white"
      />
    </svg>
  );
}

export default FacebookWhite;
